import { FETCH_SHIPMENT_COUNT_FAILURE, FETCH_SHIPMENT_COUNT_REQUEST, FETCH_SHIPMENT_COUNT_REST, FETCH_SHIPMENT_COUNT_SUCCESS } from "../../actions";
const initialState = {
    fetchShipmentCount: null,
    isLoading: false,
    error: null,
};
const shipmentCountReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SHIPMENT_COUNT_REQUEST:
            return Object.assign(Object.assign({}, state), { isLoading: true, error: null });
        case FETCH_SHIPMENT_COUNT_SUCCESS:
            return Object.assign(Object.assign({}, state), { fetchShipmentCount: action.payload, isLoading: false, error: null });
        case FETCH_SHIPMENT_COUNT_FAILURE:
            return Object.assign(Object.assign({}, state), { isLoading: false, error: action.payload });
        case FETCH_SHIPMENT_COUNT_REST:
            return initialState;
        default:
            return state;
    }
};
export default shipmentCountReducer;
